<sc-action-icon mat-icon-button iconClass="fa-link"
    *ngIf="cps.isPropertyTrue(TMCClientParameters.FEATURES_LINK_TRANSPORTS, false)"
    (click)="linkTransports()"
    [disabled]="disabled && !asButton"
    dictionaryKey="tmc-yard.ui.control.sac-client.station-transport-details.action.link">
</sc-action-icon>
